import React from 'react'

import { IconStyles } from '../types'
import { DeleteCustom } from './styles'

// import { Container } from './styles';

interface DeleteIconProps extends IconStyles {
  onClick?: any
  disabled?: boolean
}

export const DeleteIcon: React.FC<DeleteIconProps> = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  disabled
}) => {
  return (
    <DeleteCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={disabled ? null : onClick}
      disabled={disabled}
      colorIcon={colorIcon}
    />
  )
}
